import type {
  FormBuilder_Style_Theme,
  SessionHydration_Asset_Image,
} from '~/graphql/types';
import getUnionImageUrl from '~/util/getUnionImageUrl';
import removeTypenames from '~/util/removeTypenames';

type ColorPair = {
  background: string; // Hex color
  color: string; // Hex color
};

export type BrandSettings = {
  type: 'theme';
  logo: {
    url?: string;
    image?: {
      src: string;
    };
  };
  colors: {
    primary: ColorPair;
    secondary: ColorPair;
  };
};

const formatTheme = (
  input: FormBuilder_Style_Theme,
  assets: Array<SessionHydration_Asset_Image>,
): BrandSettings => {
  const logoImageUrl = getUnionImageUrl(input.logo, assets);

  return {
    logo: {
      // Url is required (an error will be shown otherwise) if logo is uploaded, but if logo is NOT uploaded, url is undefined
      url: input.logoLink ?? undefined,
      image: logoImageUrl ? { src: logoImageUrl } : undefined,
    },

    colors: {
      primary: removeTypenames(input.colors.primary),
      secondary: removeTypenames(input.colors.secondary),
    },
    type: 'theme',
  };
};

export default formatTheme;
